import React from 'react';

export default function SizeGuideImages({
  imageSet,
}) {
  const imagesToDisplay = [];
  if (imageSet?.model?.length >= 3) {
    imagesToDisplay.push(
      imageSet?.model[0],
      imageSet?.model[2],
    );
  } else if (imageSet?.model?.length >= 1
    && imageSet.prod?.length >= 1) {
    imagesToDisplay.push(
      imageSet?.model[0],
      imageSet.prod[0],
    );
  } else {
    imagesToDisplay.push(imageSet?.prod[0]);
  }

  return (
    <div className="size-guide-images-mfe">
      {imagesToDisplay.map((image) => (
        <div className="size-guide-image-mfe" key={image?.imageId + Math.random()}>
          <img key={image?.imageId + Math.random()} src={image?.mainImageSrc} data-image-id={image?.imageId} alt="prod" itemProp="image" />
        </div>
      ))}
    </div>
  );
}
